/* @flow */
import GroupStore from 'groups/stores/GroupStore';
import Device from 'entities/Device';
import DeviceActions from 'actions/DeviceActions';
import LinkSmsDevicePage from 'user/components/LinkSmsDevicePage.jsx';
import Modal from 'components/Modal.jsx';
import React from 'react';

class LinkSmsDeviceModal extends React.Component {
  static propTypes = {
    replaceDevice: React.PropTypes.instanceOf(Device),
  };

  onDone = () => {
    // The API delete the old sms device when we verify a new one,
    // hence we only have to do a local delete to remove from the store.
    if (this.props.replaceDevice) {
      DeviceActions.localDelete(this.props.replaceDevice);
    }

    // we might have new subscriptions!
    GroupStore.invalidate();
    this.props.onRequestHide();
  };

  render() {
    return (
      <Modal {...this.props}>
        <LinkSmsDevicePage
          closable
          onDone={this.onDone}
          onRequestHide={this.props.onRequestHide}
        />
      </Modal>
    );
  }
}

export default LinkSmsDeviceModal;



// WEBPACK FOOTER //
// ./src/user/components/LinkSmsDeviceModal.jsx